<template>
  <of-dialog
    title="组织架构选择器"
    :appendToBody="true"
    @onCancel="close"
    @onConfirm="confirm"
    @onDialogResize="dialogResize"
    confirmName="确 定"
    width="45%"
  >
    <div slot="content" style="padding:10px">
      <el-row :gutter="20">
        <el-col :span="14">
          <div class="panel department-nav">
            <header>待选项</header>
            <div class="content" ref="leftArea">
              <div class="tree-nav">
                <!-- <el-row :gutter="10" class="tree-search">
                  <el-col :span="17">
                    <el-input placeholder="输入关键字" :disabled="isLoading" size="small">
                      <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                  </el-col>
                  <el-col :span="7" style="text-align:center">
                    <el-button size="small" :disabled="isLoading">
                      expandText
                    </el-button>
                  </el-col>
                </el-row>-->
                <el-tree
                  :lazy="lazyLoad"
                  :load="loadTreeData"
                  :data="treeData"
                  ref="ofTree"
                  v-loading="isLoading"
                  node-key="id"
                  :show-checkbox="multiple"
                  :check-strictly="checkStrictly"
                  @node-click="selectNode"
                  @check-change="checkNode"
                >
                  <span class="tree-node" slot-scope="{ node, data }">
                    <!-- <i v-show="showIcon" class="tree-node-icon" :class="iconClassName ? iconClassName : (data.icon?data.icon:'el-icon-menu')"></i> -->
                    <span>{{ data.text }}</span>
                  </span>
                </el-tree>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="panel options-nav">
            <header>
              已选项
              <span>{{departmentCheckedData.length}}/{{departmentCheckedData.length}}</span>
            </header>
            <div class="content" ref="rightArea">
              <el-checkbox-group v-model="departmentCheckedData" @change="checkedChange">
                <p v-for="item in departmentData" :key="item.id">
                  <el-checkbox :label="item.id" :checked="item.checked">{{item.text}}</el-checkbox>
                </p>
              </el-checkbox-group>
              <p class="no-more" v-show="!departmentCheckedData.length">无数据</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </of-dialog>
</template>

<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import { queryDepartmentPickData } from "@/modules/sys/api/department.js";
import { truncate } from "fs";

export default {
  name: "sys-department-picker",
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    checkStrictly: {
      type: Boolean,
      default: false
    },
    checkedData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    lazyLoad: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      treeData: [],
      isLoading: false,
      departmentUrl: "/Sys/Picker/queryDepartmentTree",
      departmentData: [],
      departmentCheckedData: []
    };
  },
  components: {
    OfDialog
  },
  mounted() {
    this.checkedData.forEach(x => {
      this.departmentData.push(x);
      this.departmentCheckedData.push(x.id);
    });
    // this.loadTreeData()
  },
  methods: {
    loadTreeData(node, resolve) {
      node.level === 0 && (this.isLoading = true)
      queryDepartmentPickData(node.level === 0 ? "" : node.key).then(rep => {
        this.isLoading = false;
        if (rep.data && rep.data.Code === 0) {
          return resolve(rep.data.Data);
        }
      }).catch(ex=>{
         this.isLoading = false;
      })
    },
    close() {
      this.$emit("pickerCallBack", null);
    },
    confirm() {
      if (this.departmentData.length === 0) {
        this.$message({
          message: "请选择部门",
          type: "warning"
        });
      } else {
        this.$emit(
          "pickerCallBack",
          this.multiple ? this.departmentData : this.departmentData[0]
        );
      }
    },
    checkNode(data, checked) {
      if (checked) {
        this.departmentData.push(data);
        this.departmentCheckedData.push(data.id);
      } else {
        let index = this.departmentData.findIndex(x => x.id === data.id);
        if (index > -1) {
          this.departmentData.splice(index, 1);
        }
        index = this.departmentCheckedData.findIndex(x => x === data.id);
        if (index > -1) {
          this.departmentCheckedData.splice(index, 1);
        }
      }
    },
    checkedChange(items) {
      if (this.multiple) {
        let filterDate = [];
        if (items.length > 0) {
          this.departmentData.forEach(x => {
            const index = items.findIndex(f => f === x.id);
            if (index > -1) {
              filterDate.push(x.id);
            }
          });
        }
        //this.$refs.departmentTree.$refs.ofTree.setCheckedKeys(filterDate);
        this.$refs.ofTree.setCheckedKeys(filterDate);
      } else {
        this.departmentData = [];
        this.departmentCheckedData = [];
      }
    },
    /* eslint-disable */
    selectNode(data, n, e) {
      if (!this.multiple) {
        this.departmentData = [];
        this.departmentCheckedData = [];
        this.departmentData.push(data);
        this.departmentCheckedData.push(data.id);
      }
    },
    dialogResize(height) {
      let leftArea = this.$refs.leftArea;
      let rightArea = this.$refs.rightArea;

      height -= 80;
      if (leftArea) {
        leftArea.style.maxHeight = `${height}px`;
        leftArea.style.minHeight = `${height}px`;
      }
      if (rightArea) {
        rightArea.style.maxHeight = `${height}px`;
        rightArea.style.minHeight = `${height}px`;
      }
    }
  }
};
</script>
<style scoped>
.panel {
  border: 1px solid #ebeef5;
  overflow: hidden;
  width: 100%;
  border-radius: 3px;
}
.department-nav {
  min-width: 300px;
}
.options-nav {
  min-width: 200px;
}
.panel > header {
  background: #f5f7fa;
  padding: 5px 10px 5px 10px;
  border-bottom: 1px solid #ebeef5;
  position: relative;
}
.panel > header > span {
  position: absolute;
  right: 15px;
  color: #909399;
  font-size: 12px;
  font-weight: 400;
}
.panel > .content {
  padding: 10px;
  overflow: auto;
}
.no-more {
  padding: 5px;
  color: #909399;
  text-align: center;
}
</style>
